// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--TW36s","label":"dd31006766--label--wmL33"};